import { c as _c } from "react/compiler-runtime";
import { type KeyboardEvent, useRef } from "react";

/** Returns a ref for the Save button and a textarea keydown handler that focuses it on Cmd/Ctrl+Enter. */
export function useSaveButtonShortcut() {
  const $ = _c(1);
  const saveButtonRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const handleDetailsKeyDown = event => {
      if (event.key !== "Enter" || !event.metaKey && !event.ctrlKey) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      saveButtonRef.current?.focus();
    };
    t0 = {
      handleDetailsKeyDown,
      saveButtonRef
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}